import { Route, Routes } from 'react-router-dom';
import { SelectName } from './pages/SelectName';
import { PinEntry } from './pages/PinEntry';
import { Punch } from './pages/Punch';
import { PunchSuccess } from './pages/PunchSuccess';
import { ChangePin } from './pages/ChangePin';
import { Nenmatsu } from './pages/Nenmatsu';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<SelectName />} />
      <Route path="/pin/:employeeId" element={<PinEntry />} />
      <Route path="/punch" element={<Punch />} />
      <Route path="/punch/success/:type" element={<PunchSuccess />} />
      <Route path="/change-pin" element={<ChangePin />} />
      <Route path="/nenmatsu" element={<Nenmatsu />} />
      <Route path="*" element={<SelectName />} />
    </Routes>
  );
}
